package com.sweetlime.bingeamigo.presentation.features.tvdetail

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.bingeamigo.model.TvShowDetail
import com.sweetlime.bingeamigo.repository.TmdbRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed class TvShowDetailState {
    data object Loading : TvShowDetailState()
    data class Success(val detail: TvShowDetail) : TvShowDetailState()
    data class Error(val message: String) : TvShowDetailState()
}

class TvShowDetailViewModel(
    private val repository: TmdbRepository
) : ViewModel() {

    private val _state = MutableStateFlow<TvShowDetailState>(TvShowDetailState.Loading)
    val state: StateFlow<TvShowDetailState> = _state.asStateFlow()

    fun load(tvShowId: Int) {
        _state.value = TvShowDetailState.Loading
        viewModelScope.launch {
            val detail = repository.getTvShowDetail(tvShowId)
            _state.value = if (detail != null) {
                TvShowDetailState.Success(detail)
            } else {
                TvShowDetailState.Error("Failed to load show details")
            }
        }
    }
}